import { queryClient } from '../../query';
import { callPatchApi, callGetApi, callPostApi } from '../apiCallerProxy';
import { createSitesApi } from './sitesApiFactory';

export * from './hooks';
export default createSitesApi({ callGetApi, callPatchApi, callPostApi, queryClient });
